import { render, staticRenderFns } from "./PublicHolidaySetup.vue?vue&type=template&id=46268c73&scoped=true"
import script from "./PublicHolidaySetup.vue?vue&type=script&lang=ts"
export * from "./PublicHolidaySetup.vue?vue&type=script&lang=ts"
import style0 from "./PublicHolidaySetup.vue?vue&type=style&index=0&id=46268c73&prod&scoped=true&lang=scss"
import style1 from "./PublicHolidaySetup.vue?vue&type=style&index=1&id=46268c73&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46268c73",
  null
  
)

export default component.exports